import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreSalesLostReasonService {
  constructor(private ws: PostmethodService) { }

  preSalesReasonCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "preSalesLostReasonsMaster");
  }
}
